import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { HeartHandshake, Mail, Phone } from "lucide-react";

const SUBJECT = encodeURIComponent("Richiesta SIM Italia Mobile");
const BODY = encodeURIComponent("Ciao, ho finito le SIM Italia Mobile: me ne puoi assegnare qualcuna su MarkooPlace? Grazie!");

export const MasterSimContact = ({ reason }) => {
  const [m, setM] = useState(undefined);
  useEffect(() => { api.get("/me/upline").then((r) => setM((r.data.contacts || []).find((c) => c.kind === "master") || null)).catch(() => setM(null)); }, []);
  return (
    <div className="rounded-xl border border-primary/25 bg-primary/5 p-4 flex flex-wrap items-start gap-4" data-testid="sim-order-blocked">
      <div className="w-11 h-11 rounded-full bg-primary/15 text-primary flex items-center justify-center shrink-0"><HeartHandshake className="w-5 h-5" /></div>
      <div className="flex-1 min-w-[220px] space-y-1">
        <p className="font-semibold" data-testid="sim-master-title">Le tue SIM arrivano dal tuo master{m?.name ? <>: <span className="text-primary" data-testid="sim-master-name">{m.name}</span></> : ""}</p>
        <p className="text-sm text-muted-foreground">Nella tua rete è il master che ordina le SIM Italia Mobile e le assegna a te. Scrivigli o chiamalo: appena te le passa le trovi qui e puoi attivare subito i tuoi clienti.</p>
        {m && (m.phone || m.email) && <div className="flex flex-wrap gap-2 pt-2">
          {m.phone && <Button asChild size="sm" variant="outline" className="gap-1.5"><a href={`tel:${m.phone.replace(/\s/g, "")}`} data-testid="sim-master-phone"><Phone className="w-4 h-4" />{m.phone}</a></Button>}
          {m.email && <Button asChild size="sm" variant="outline" className="gap-1.5"><a href={`mailto:${m.email}?subject=${SUBJECT}&body=${BODY}`} data-testid="sim-master-email"><Mail className="w-4 h-4" />{m.email}</a></Button>}
        </div>}
        {m === null && reason && <p className="text-xs text-muted-foreground" data-testid="sim-master-reason">{reason}</p>}
      </div>
    </div>
  );
};
